import React from 'react'
import Loadable from 'react-loadable'
import Loading from '../../components/loader/Loader'
import RolesEnum from '../../Enum/RolesEnum';

const FinancasPedidosComponent = Loadable({
  loader: () => import('../../../pages/financas/pedidos/FinancasPedidos'),
  loading: () => <Loading />
})

const FinancasBalancosComponent = Loadable({
  loader: () => import('../../../pages/financas/balancos/FinancasBalancos'),
  loading: () => <Loading />
})

export default [
  {
    path: '/financas/pedidos',
    title: 'Finaças - Pedidos',
    component: FinancasPedidosComponent,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.FuncionarioUpgas, RolesEnum.Organizacao]
  },
  {
    path: '/financas/balancos',
    title: 'Finaças - Balanços',
    component: FinancasBalancosComponent,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.FuncionarioUpgas, RolesEnum.Organizacao]
  }
]
